export default "__VITE_ASSET__659a23da__"